import { Button } from '@heroui/react';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { PageTitle, PageWrapper } from '../../../components';
import { useHeroToast } from '../../../hooks';
import { AdRequest, usePostAd } from '../../../queries';
import { AdForm } from '../components';

const FORM_ID = 'form-create-ad';

export const AdCreate: FC = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useHeroToast();
  const { mutate: create, isPending } = usePostAd();

  const handleSubmit = (data: AdRequest): void => {
    create(
      { data },
      {
        onSuccess: (result) => {
          const assigned = result.assigned_hotels?.length ?? 0;
          const skipped = result.skipped ?? [];
          if (skipped.length > 0) {
            showError(`Reklama utworzona, ale pominięto ${skipped.length} hoteli — brak dokumentu w bazie: ${skipped.join(', ')}`);
          } else {
            showSuccess(
              assigned > 0
                ? `Reklama utworzona i widoczna w ${assigned} hotelach`
                : 'Reklama utworzona — przypisz jej hotele, żeby stała się widoczna',
            );
          }
          navigate('/ads');
        },
        onError: (error) => showError(error.message || 'Nie udało się utworzyć reklamy'),
      },
    );
  };

  return (
    <PageWrapper>
      <PageTitle
        title="Nowa reklama"
        actions={(
          <Button
            size="sm"
            color="secondary"
            radius="sm"
            type="submit"
            form={FORM_ID}
            isLoading={isPending}
          >
            Zapisz
          </Button>
        )}
      />
      <AdForm onSubmit={handleSubmit} formDataId={FORM_ID} withHotels />
    </PageWrapper>
  );
};
